
/* popup enquiry form on product page */

  // document.addEventListener("DOMContentLoaded", function () {
  //   const showFormBtn = document.querySelector(".showFormBtn");
  //   const formWrapper = document.querySelector(".form_wrapper");
  //   const overlay = document.querySelector(".form_overlay");
  //   const closeBtn = document.querySelector(".form_close_btn");

  //   const openForm = () => {
  //     formWrapper.classList.add("active");
  //     overlay.classList.add("active");
  //     document.body.classList.add("modal-open"); 
  //   };

  //   const closeForm = () => {
  //     formWrapper.classList.remove("active");
  //     overlay.classList.remove("active");
  //     document.body.classList.remove("modal-open"); 
  //   };

  //   showFormBtn.addEventListener("click", openForm);
  //   overlay.addEventListener("click", closeForm);
  //   closeBtn.addEventListener("click", closeForm);
  // });


document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".showFormBtn");
  const overlays = document.querySelectorAll(".form_overlay");
  const forms = document.querySelectorAll(".form_wrapper");
  const closeButtons = document.querySelectorAll(".form_close_btn");

  const openForm = (formId) => {
    document.querySelector(`#form_wrapper_${formId}`).classList.add("active");
    document.querySelector(`#form_overlay_${formId}`).classList.add("active");
    document.body.classList.add("modal-open");
  };

  const closeForm = (formId) => {
    document.querySelector(`#form_wrapper_${formId}`).classList.remove("active");
    document.querySelector(`#form_overlay_${formId}`).classList.remove("active");
    document.body.classList.remove("modal-open");
  };

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const formId = button.getAttribute("data-form");
      openForm(formId);
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener("click", () => {
      const formId = button.getAttribute("data-target");
      closeForm(formId);
    });
  });

  overlays.forEach((overlay, index) => {
    overlay.addEventListener("click", () => {
      const formId = index + 1; 
      closeForm(formId);
    });
  });
});

